<mat-dialog-content class="dialog_content">
  <app-paragraph textAlign="center" class="mt_30 mb_30 fs-h2 fw_bold">
        {{'allShare.title' | translate}}
  </app-paragraph>
  <p class="dialog-message">
    {{'share.choose' | translate}}
  </p>
  <form id="form">
    <div class="input_wrapper mt_20">
      <select (change)="setClaim($event)" formControlName="claim">
        <option value="" disabled></option>
        <option value="-">{{'share.all' | translate}}</option>
        <option *ngFor="let claim of claims" [value]="'' + claim">{{('userShare.DYN.' + claim) | translate}}</option>
      </select>
    </div>

    <div class="f_between mt_20 dialog_bot_btns">
      <app-button size="sm" color="warn" (click)="closeDialog()">{{'global.close' | translate}}</app-button>
      <app-button size="sm" type="submit" formId="form" [disabled]="this.claim === undefined" (click)="closeDialog(this.claim)">{{'global.share' | translate}}</app-button>
    </div>
  </form>
</mat-dialog-content>